<template>
  <v-card variant="outlined" style="overflow: visible; border-color: light-dark(rgb(118, 118, 118), rgb(133, 133, 133));">
    <span
      class="text-caption ms-3 px-1"
      style="position: absolute; top: -14px; background-color: white; z-index: 999;"
    >
      {{ label ?? 'Entradas' }}
    </span>
    <v-card-text>
      <v-row v-for="(entry, index) in model" :key="index">
        <v-col cols="12" md="5">
          <v-text-field
            v-model="entry.key"
            variant="outlined"
            label="Chave"
            :readonly="readonly"
            hide-details="auto"
            density="compact"
          />
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            v-model="entry.value"
            variant="outlined"
            label="Valor"
            :readonly="readonly"
            hide-details="auto"
            density="compact"
          />
        </v-col>
        <v-col cols="12" md="1" class="d-flex align-center">
          <v-row>
            <v-col>
              <v-btn
                v-if="!readonly"
                icon
                size="small"
                color="error"
                variant="tonal"
                @click="remove(index)"
              >
                <v-icon>fa-solid fa-times</v-icon>
              </v-btn>
            </v-col>
            <v-col>
              <v-btn
                v-if="!readonly"
                icon
                size="small"
                color="primary"
                variant="tonal"
                @click="add"
              >
                <v-icon>fa-solid fa-plus</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row v-if="model.length === 0">
        <v-col cols="12" class="text-center text-grey">
          Nenhuma credencial adicionada
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue'

interface Props {
  readonly: boolean
  label?: string
}

interface CredentialEntry {
  key: string
  value: string
}

const { readonly } = defineProps<Props>()

const model = defineModel<CredentialEntry[]>({
  required: true,
  default: () => [],
})

function add() {
  model.value.push({ key: '', value: '' })
}

function remove(index: number) {
  model.value.splice(index, 1)
}

onMounted(() => {
  if (model.value.length === 0) {
    add()
  }
})
</script>
